export const projectData = [
  {
    id: 9,
    slug: "ecobook-ai-automation",
    src: "/accounting.jpg",
    alt: "AI-powered automation dashboard for accounting",
    title: "Ecobook AI Automation",
    subtitle: "AI-Powered Automation for Accounting Operations",
    description:
      "AI-driven automation built for Ecobook.se, a Swedish accounting firm - optimizing client onboarding, document handling, tax tasks, and lead generation to enhance efficiency and reduce manual workload.",
    keyFeatures: [
      "Automated client onboarding with OCR and AI validation.",
      "AI-driven document classification and processing.",
      "Recurring tax and VAT submission workflows with reminders.",
      "CRM-integrated client acquisition recommendations using LLMs.",
      "Secure data handling compliant with European standards.",
      "Productivity dashboards for accountants and admins.",
    ],
    projectLink: "",
    detailImageSrc: "/ecobookse.png"
  },
  {
    id: 1,
    slug: "easy-dropship",
    src: "/b2b.jpg",
    alt: "EasyDropShip interface image",
    title: "EASY DROPSHIPPING",
    subtitle: "A B2B E-commerce Platform for Bulk Purchasing at Wholesale Prices",
    description:
      "EasyDropShip is a web-based platform designed to simplify bulk product sourcing for shop owners. Built with a focus on affordability and user experience, the platform allows retailers to browse a wide range of products, compare wholesale prices, and place large orders effortlessly. It bridges the gap between suppliers and retailers by offering a seamless and reliable dropshipping solution tailored for scale.",
    keyFeatures: [
      "User-friendly product browsing and filtering.",
      "Bulk pricing options for shop owners.",
      "Secure checkout and order management.",
      "Optimized for performance across devices.",
    ],
    projectLink: "https://www.easydropship.net/",
    detailImageSrc: "/easy-dropship-detail.jpg",
  },
  {
    id: 2,
    slug: "anypaper-pro",
    src: "/project3.png",
    alt: "AnyPaper Pro interface image",
    title: "ANYPAPER PRO",
    subtitle: "Digital Document Collaboration and Workflow",
    description:
      "AnyPaper Pro is a student-focused platform that connects learners with academic experts for help with assignments, projects, research papers, and presentations. Built for speed and convenience, it allows students to upload their academic tasks and get personalized assistance - all within their deadline.",
    keyFeatures: [
      "Pay-per-task model - no subscriptions",
      "Connects students directly with qualified experts",
      "Support for assignments, projects, research, and presentations",
      "Built-in plagiarism check and AI-enhanced assistance",
      "Secure file uploads and deadline tracking",
      "Real-time notifications and task updates",
    ],
    projectLink: "https://www.anypaperpro.com/",
    detailImageSrc: "/anypaper-pro-detail.jpg",
  },
  {
    id: 4,
    slug: "facture-sigma",
    src: "/project2.png",
    alt: "Facture Sigma interface image",
    title: "FACTURE SIGMA",
    subtitle: "Streamlined Invoicing and Financial Management",
    description:
      "Facture Sigma provides businesses with an intuitive platform for creating, sending, and managing invoices. It integrates financial tracking tools to offer insights into cash flow and business performance.",
    keyFeatures: [
      "Professional invoice creation.",
      "Automated payment reminders.",
      "Expense tracking integration.",
      "Financial reporting dashboards.",
    ],
    projectLink: "https://facturesite.netlify.app/",
    detailImageSrc: "/facture-sigma-detail.jpg",
  },
  {
    id: 5,
    slug: "trendy-story",
    src: "/project4.png",
    alt: "Businessman holding digital concept",
    title: "Trendy Story",
    subtitle: "AI-Powered News Story & Thumbnail Generator",
    description:
      "Trendystory is an intelligent content creation tool that fetches the top 5 trending news stories from any country and automatically generates unique narratives and matching thumbnails. Users simply select their preferred tone—horror, formal, romantic, etc.—and Trendystory produces a formatted news story and thumbnail optimized for social media, blogs, or marketing campaigns.",
    keyFeatures: [
      "Fetches top 5 trending news by country",
      "AI-generated story text tailored to chosen tone (horror, formal, romantic, humorous, etc.)",
      "Auto-generated thumbnails matching the story tone",
      "Formats output ready for social media or blog publishing",
      "User-selectable story tone/style with one click",
      "Export options: image + text or full media post package",
    ],
    projectLink: "",
    detailImageSrc: "/trendystory.jpg",
  },
  {
    id: 6,
    slug: "skillforge",
    src: "/skillforge.jpg",
    alt: "User browsing courses on a mobile app",
    title: "SkillForge",
    subtitle: "Unlock Your Potential with Expert-Led Courses",
    description:
      "SkillForge is a dynamic platform built with Flutter, allowing users to explore, purchase, and access a wide range of programming courses. With a sleek interface and powerful search features, SkillForge empowers users to learn new skills and advance their careers at their own pace.",
    keyFeatures: [
      "User authentication and login system.",
      "Course browsing and searching by category.",
      "Secure payment gateway for course purchase.",
      "Downloadable course content and videos.",
      "Course progress tracking and reminders.",
    ],
    projectLink: "",
    detailImageSrc: "/flutterproject.jpg",
  },
  {
    id: 7,
    slug: "clinic-management",
    src: "/clinic.jpg",
    alt: "clinic management system",
    title: "CLINIC MANAGEMENT SYSTEM",
    subtitle: "Desktop Application for Streamlined Healthcare Operations",
    description:
      "The Clinic Management System is a powerful desktop-based solution designed to simplify and automate daily operations in small to mid-sized clinics. It centralizes all key activities—from patient registration to lab reports—and ensures smooth coordination between doctors, receptionists, and lab staff.",
    keyFeatures: [
      "View appointments, patient history, and medical records",
      "Registration, visit tracking, and treatment history",
      "Appointment scheduling, billing, and patient queue management",
      "Test assignment, result entry, and report generation",
      "Role-based login for secure access and task management",
      "Searchable patient and test history",
      "Offline functionality - no internet required for daily use",
      "Printable reports and prescriptions",
    ],
    projectLink: "",
    detailImageSrc: "/clinicsystem.jpg",
  },
 
];


export const getProjectBySlug = (slug) => {
  return projectData.find((project) => project.slug === slug);
};
